import {Component, Inject} from '@angular/core';
import {DIALOG_DATA, DialogRef} from '@angular/cdk/dialog';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';

export interface TagDialogData {
  headline: string;
  actionName: string;
  tag: { key: string; value: string };
}

/** Closes with the confirmed tag, or nothing when the operator cancels. */
export type TagDialogResult = { key: string; value: string } | undefined;

@Component({
  selector: 'app-tag-dialog',
  templateUrl: './tag-dialog.component.html',
  imports: [ReactiveFormsModule],
})
export class TagDialogComponent {
  readonly form: FormGroup<{ key: FormControl<string>; value: FormControl<string> }>;

  constructor(public dialogRef: DialogRef<TagDialogResult>,
              @Inject(DIALOG_DATA) public data: TagDialogData) {
    this.form = new FormGroup({
      key: new FormControl(data.tag.key, {nonNullable: true, validators: [Validators.required]}),
      value: new FormControl(data.tag.value, {nonNullable: true}),
    });
  }

  /** The key is empty, shown once the operator has touched the field. */
  get keyMissing(): boolean {
    const control = this.form.controls.key;
    return control.invalid && (control.touched || control.dirty);
  }

  confirm(): void {
    if (this.form.invalid) {
      return;
    }
    this.dialogRef.close(this.form.getRawValue());
  }
}
